import {
  EXPERIENCED_SKIPABLE_SCREEN,
  FRESHER_SKIPABLE_SCREEN,
  regScreen,
} from "@/components/registration/map";

type Props = {
  siteMap: string;
  isExperienced: boolean;
  screen: (typeof regScreen)[number];
};
export const getIsRegScreenSkipable = ({
  siteMap,
  isExperienced,
  screen,
}: Props) => {
  switch (siteMap) {
    case "rexmonster":
    case "monstergulf":
    case "monstergulf":
    case "monstersingapore":
    case "monsterthailand":
    case "monsterphilippines":
    case "monstervietnam":
    case "monsterindonesia":
    case "monsterhongkong":
      return isExperienced
        ? EXPERIENCED_SKIPABLE_SCREEN.includes(screen)
        : FRESHER_SKIPABLE_SCREEN.includes(screen);

    case "monstermalaysia":
      return isExperienced ? ["RESUME", "LINKEDIN"].includes(screen) : false;

    default:
      return false;
  }
};
